import { ActionsV2__communicationType } from 'app/promotionsv2/actions/actions-edit/store/actionsV2-FormStateModel';
import { MessageStructuresModel } from '../models/messageStructuresList.models';
import { PagedList } from 'core/models/paged-list.model';

export const DUMMY_MESSAGE_STRUCTURES: MessageStructuresModel[] = [
  {
    id: 1,
    name: 'Descuento para producto simple',
    code: 'EST-001',
    communicationType: ActionsV2__communicationType.CommunicateDiscount,
    isDefaultMessageStructure: true,
    inUse: false,
    chips: [
      {
        id: 15,
        order: 0,
      },
      {
        id: 29,
        order: 1,
      },
      {
        id: 34,
        order: 2,
      },
      {
        id: 57,
        order: 3,
      },
      {
        id: 103,
        order: 4,
      },
    ],
  },

  {
    id: 2,
    name: 'Descuento para producto simple con texto de apoyo',
    code: 'EST002',
    communicationType: ActionsV2__communicationType.CommunicateDiscount,
    isDefaultMessageStructure: false,
    inUse: false,
    chips: [
      {
        id: 15,
        order: 0,
      },
      {
        id: 29,
        order: 1,
      },
      {
        id: 34,
        order: 2,
      },
      {
        id: 57,
        order: 3,
      },
      {
        id: 103,
        order: 4,
      },
      {
        id: 49,
        order: 5,
      },
      {
        id: 49,
        order: 6,
      },
      {
        id: 58,
        order: 7,
      },
    ],
  },
  {
    id: 3,
    name: 'Estructura Mensaje 3',
    code: 'EST003',
    communicationType: ActionsV2__communicationType.CommunicateDiscount,
    isDefaultMessageStructure: false,
    inUse: true,
  },
  {
    id: 4,
    name: 'Estructura Mensaje 4',
    code: 'EST004',
    communicationType: ActionsV2__communicationType.CommunicateDiscount,
    isDefaultMessageStructure: false,
    inUse: true,
  },
  {
    id: 5,
    name: 'Estructura Mensaje 5',
    code: 'EST005',
    communicationType: ActionsV2__communicationType.CommunicateDiscount,
    isDefaultMessageStructure: false,
    inUse: false,
  },
  {
    id: 6,
    name: 'Precio para producto simple',
    code: 'EST-006',
    communicationType: ActionsV2__communicationType.CommunicatePrice,
    isDefaultMessageStructure: true,
    inUse: false,
    chips: [
      {
        id: 15,
        order: 0,
      },
      {
        id: 101,
        order: 1,
      },
      {
        id: 341,
        order: 2,
      },
      {
        id: 103,
        order: 3,
      },
    ],
  },
  {
    id: 7,
    name: 'Estructura Mensaje 7',
    code: 'EST007',
    communicationType: ActionsV2__communicationType.CommunicatePrice,
    isDefaultMessageStructure: false,
    inUse: false,
  },
  {
    id: 8,
    name: 'Estructura Mensaje 8',
    code: 'EST008',
    communicationType: ActionsV2__communicationType.CommunicatePrice,
    isDefaultMessageStructure: false,
    inUse: false,
  },
  {
    id: 9,
    name: 'Estructura Mensaje 9',
    code: 'EST009',
    communicationType: ActionsV2__communicationType.CommunicatePrice,
    isDefaultMessageStructure: false,
    inUse: false,
  },
  {
    id: 10,
    name: 'Estructura Mensaje 10',
    code: 'EST010',
    communicationType: ActionsV2__communicationType.CommunicatePrice,
    isDefaultMessageStructure: false,
    inUse: false,
  },
];

export const _mapDummyDataToPagedList = (
  data: MessageStructuresModel[],
  includechips: boolean = false,
  communicationType: ActionsV2__communicationType = null
): PagedList<MessageStructuresModel> => {
  return {
    items: _filterDataByCommunicationType(data, communicationType, includechips),
    totalItemCount: data.length,
    pageIndex: 1,
    pageSize: data.length,
  };
};

const _filterDataByCommunicationType = (
  data: MessageStructuresModel[],
  communicationType: ActionsV2__communicationType,
  includechips: boolean = false
): MessageStructuresModel[] => {
  const filteredData = communicationType ? data.filter(item => item.communicationType === communicationType) : data;
  return includechips ? filteredData : filteredData.map(({ chips, ...rest }) => rest);
};
